import { html } from "../../base/_utils";

export default function staffModal(member, path) {
    return html`
        <div id="${member.id}-modal" class="staff-modal modal fade" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header border-0 d-flex align-items-start">
                        <img class="img-fluid staff-image w-35" src="${path}${member.image}" />
                        <div class="w-100 ms-3">
                            <p class="h3 fs-3 staff-name">
                                ${member.name.split(" ")[0]}<br />
                                ${member.name.split(" ")[1]}
                            </p>
                            <p class="mb-2 staff-title">${member.title}</p>
                            ${member.phone ? html`<p class="mb-0 small"><a class="staff-phone" href="tel:+1${member.phone}">${member.phone}</a></p>` : ""}
                            ${member.phone ? html`<p class="mb-0 small"><a class="staff-email link" href="mailto:${member.email}">${member.email}</a></p>` : ""}
                            <hr />
                        </div>
                        <i type="button" data-bs-dismiss="modal" aria-label="Close" class="bi bi-x-lg fs-5"></i>
                    </div>
                    <div class="modal-body">${member.bio}</div>
                </div>
            </div>
        </div>
    `;
}
